"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = postSearch;
const client_1 = __importDefault(require("../../client/client"));
async function postSearch(config, options, pageParam) {
    // Prepare the request body
    const requestBody = {
        query: options.q,
        types: options.types,
        orderBy: options.orderBy || 0,
        to: options.to,
        from: options.from,
        platform: "headless",
    };
    return client_1.default.post(config["API_URL"], `/search?start=${pageParam}`, requestBody);
}
